// /assets/judgeme-expand.js
document.addEventListener("DOMContentLoaded", function () {
    const masonrySection = document.querySelector('section.jdgm-masonry-grid');
    if (!masonrySection) return;

    // 实时清除 max-height 限制
    const removeMaxHeight = () => {
        if (masonrySection.style.maxHeight && masonrySection.style.maxHeight !== 'none') {
            masonrySection.style.maxHeight = 'none';
        }
    };
    removeMaxHeight();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'style') {
                removeMaxHeight();
            }
        });
    });
    observer.observe(masonrySection, { attributes: true });

    // 智能连续加载更多评论
    let maxClicks = 3; 
    let clickCount = 0;

    const triggerLoadMore = () => {
        const btn = document.querySelector('.jdgm-masonry-grid__btn');
        if (btn && clickCount < maxClicks) {
            const isVisible = btn.offsetParent !== null; 
            const isLoading = btn.classList.contains('is-loading');

            if (isVisible && !isLoading) {
                btn.click();
                clickCount++;
                setTimeout(triggerLoadMore, 2000);
                return;
            }
        }
        if (clickCount < maxClicks) {
            setTimeout(triggerLoadMore, 1000);
        }
    };

    setTimeout(triggerLoadMore, 2500);
});